import {Box, Typography} from '@viptech/react-components'
import {useSnackbar} from 'notistack'
import {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import Slider from 'src/components/slider'
import {useAuth} from 'src/contexts/AuthContext'
import useSingleCamera from 'src/hooks/api/camera/useSingleCamera'
import useUpdateAdvancedCamera from 'src/hooks/api/camera/useUpdateAdvancedCamera'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'
import CameraConfigFooter from '../camera-config-footer/CameraConfigFooter'

function CameraAdvancedConfig() {
  const {id} = useParams<{id?: string}>()
  const {enqueueSnackbar} = useSnackbar()
  const {user} = useAuth()
  const navigate = useNavigate()

  const {data: camera, isLoading} = useSingleCamera({
    onError: (error) => handleErrorWithSnackbar(enqueueSnackbar, error, 'Falha ao tentar obter câmera'),
    cameraId: Number(id),
    params: {includes: ['configuration']},
    enabled: !!id,
  })

  const userHasEditConfigPermission = user.permissions.includes('camera-parameter-config:update')
  useEffect(() => {
    if (!userHasEditConfigPermission) navigate('forbidden')
  }, [userHasEditConfigPermission])

  const [isEditing, setIsEditing] = useState(false)
  const [detectionSensitivity, setDetectionSensitivity] = useState<number>()

  useEffect(() => {
    if (camera && camera.configuration.sensitivity) setDetectionSensitivity(camera.configuration.sensitivity * 100)
    else setDetectionSensitivity(85)
  }, [camera])

  const {mutateAsync: mutateUpdateCamera, isPending: isLoadingUpdateCamera} = useUpdateAdvancedCamera()

  return (
    <Box display='flex' direction='column' rowGap='20px'>
      <Box display='flex' direction='column' height='100%' minHeight='50vh' paddingTop='24px'>
        <Typography variant='h5' size='16px' children='Sensibilidade da detecção' />
        <Typography variant='span' size='14px' color='#8E8E8E'>
          A sensibilidade da detecção define o quão sensível a câmera se comportará. Quanto mais sensível mais chance de enviar eventos.
        </Typography>

        {!isLoading && detectionSensitivity && (
          <Box paddingTop='30px'>
            <Slider
              min={1}
              max={100}
              value={detectionSensitivity}
              setValue={setDetectionSensitivity}
              bubble
              thumbColor={isEditing ? '#258BE3' : '#79b3e6'}
              background={isEditing ? '#b9b9b9' : '#e0e0e0'}
              width='500px'
              disabled={!isEditing}
            />
            <Box display='flex' direction='row' align='center' justify='space-between' width='500px' paddingTop='8px'>
              <Typography variant='span' size='12px' children='Menos sensível' />
              <Typography variant='span' size='12px' children='Mais sensível' />
            </Box>
          </Box>
        )}
      </Box>

      <CameraConfigFooter
        isEditing={isEditing}
        onEdit={() => setIsEditing(true)}
        isLoading={isLoadingUpdateCamera}
        onCancel={() => {
          setIsEditing(false)
          setDetectionSensitivity(camera?.configuration.sensitivity ? camera?.configuration.sensitivity * 100 : 85)
        }}
        onSubmit={async () => {
          if (!camera || !detectionSensitivity) return
          await mutateUpdateCamera({
            cameraId: camera.id,
            detectionSensitivity: detectionSensitivity / 100,
          })
          setIsEditing(false)
        }}
      />
    </Box>
  )
}

export default CameraAdvancedConfig
